import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { ENDPOINTS } from "../Services/ServiceConfig";
import { RootState } from "../store/store";

export const baseQuery = fetchBaseQuery({
  baseUrl: ENDPOINTS.BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const userAccessToken = (getState() as RootState).auth.user?.accessToken;
    const ktk = sessionStorage.getItem("kqlToken") ?? undefined;
    if (userAccessToken) headers.set("authorization", `Bearer ${userAccessToken}`);
    if (ktk) headers.set("Ktk", ktk);
    return headers;
  }
});
